<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Detalhes do Ofício") }}</h1>

    <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#5895FF"
    />
    <div id="boxPrint"
         class="row">
      <div class="col-md-12">
        <print-header></print-header>
        <table
            class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
        >
          <tbody>
          <tr>
            <td colspan="2">
              Ofício nº:
              <strong
              >{{ item.numero }}/{{ item.ano }}</strong
              >
            </td>
            <td colspan="2"
                class="text-right">
              {{ getDataAtual() }}
            </td>
          </tr>
          <tr>
            <td colspan="4">
              À(ao):
              <strong>{{
                  item.nome_completo_detinatario
                }}</strong>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <strong>{{ item.orgao_destinatario }}</strong>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              Assunto: <strong>{{ item.assunto }}</strong>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div v-html="item.conteudo"></div>
            </td>
          </tr>
          <tr>
            <td colspan="4"
                class="text-center">
              {{ tipo_tratamento }}
            </td>
          </tr>
          <tr>
            <td colspan="4"
                class="text-center">
              <print-footer 
                v-if=" item.tecnico_assinatura" 
                :tecnico="item.tecnico_full" 
                class="mt-0" 
                :assinatura=" item.tecnico_assinatura"
                :wpp="wpp"
                :email="email"
              />
                   
              <strong v-else>{{ item.tecnico }}</strong>
            </td>
          </tr>
          </tbody>
        </table>

        <p class="text-muted">{{ app_cidade }}, {{ app_data_atual }}</p>

        <div class="row pt-4 px-0 d-flex justify-content-end no-print">
          <div class="col d-flex align-items-center">
            <label class="mr-1"> Tipo de tratamento:</label>
            <div class="form-check form-check-inline">
              <input
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="Atenciosamente"
                  value="Atenciosamente"
                  v-model="tipo_tratamento"
              />
              <label class="form-check-label"
                     for="inlineRadio1"
              >Atenciosamente</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="Respeitosamente"
                  value="Respeitosamente"
                  v-model="tipo_tratamento"
              />
              <label class="form-check-label"
                     for="inlineRadio2"
              >Respeitosamente</label
              >
            </div>
          </div>
          <div class="col-auto px-2 text-right">
            <form-toggle
                grid="12"
                mt="0"
                v-model="email"
                label="Email"
            />
            <form-toggle
                grid="12"
                mt="0"
                v-model="wpp"
                label="Telefone/WhatsApp"
            />
            <router-link
                :to="`/dashboard/oficios/edit/${item.id}`"
                class="btn btn-default"
            >
              <i class="mdi mdi-arrow-left"/>
            </router-link>

            <a class="btn btn-sm py-1 btn-primary"
               @click="print()">
              <i class="mdi mdi-printer mdi-18px"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      tipo_tratamento: "Atenciosamente",
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      email: true,
      wpp: true
    };
  },
  mounted() {
    this.getItem();
  },
  methods: {
    getDataAtual() {
      return this.app_cidade + "," + moment().format("LLL");
    },
    getItem() {
      axios
          .get(`api/dashboard/oficios/${this.$route.params.id}`)
          .then((response) => {
            this.item = response.data.data;
            this.loading = false;
          })
          .catch((error) => {
            this.$router.push("/dashboard/oficios/");
          });
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
  },
};
</script>

<style scoped>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
